export default __webpack_public_path__ + "static/media/Horns of the Reanimator.f33f69bb.jpg";